import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { IconUpload } from "@tabler/icons-react";

interface FloorPlanUploadProps {
  onUpload: (url: string) => void;
  hasFloorPlan: boolean;
}

export function FloorPlanUpload({ onUpload, hasFloorPlan }: FloorPlanUploadProps) {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const url = event.target?.result as string;
      onUpload(url);
    };
    reader.readAsDataURL(file);
  };

  if (hasFloorPlan) return null;

  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <button
        onClick={() => inputRef.current?.click()}
        className="pointer-events-auto flex flex-col items-center gap-4 rounded-xl border-2 border-dashed border-[#30333c] bg-[#1a1d24]/80 p-12 backdrop-blur transition-colors hover:border-teal-400 hover:bg-[#1a1d24]"
      >
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#2a2d35]">
          <IconUpload className="h-8 w-8 text-zinc-400" />
        </div>
        <div className="text-center">
          <p className="text-lg font-medium text-zinc-100">{t("warehouseMap.floorPlanUpload.title")}</p>
          <p className="mt-1 text-sm text-zinc-400">
            {t("warehouseMap.floorPlanUpload.hint")}
          </p>
        </div>
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={handleFileChange}
      />
    </div>
  );
}
